import Cookies from 'js-cookie'

const state = {
  // sidebar: {
  //   opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
  //   withoutAnimation: false
  // },
  device: 'desktop',
  isMobile: false,
  // size: Cookies.get('size') || 'medium'
}

const mutations = {

  // CLOSE_SIDEBAR: (state, withoutAnimation) => {
  //   Cookies.set('siderbarStatus', 0 )
  //   state.sidebar.opened = false
  //   state.sidebar.withoutAnimation = withoutAnimation
  // },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  }

}

const actions = {
  
  // closeSideBar({ commit },{ withoutAnimation }) {
  //   commit('CLOSE_SIDEBAR', withoutAnimation)
  // },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js